import ErrorCard from '../ErrorCard/ErrorCard';
import React from 'react';

interface State {
  error?: Error;
}

class ErrorBoundary extends React.Component<any, any> {
  public readonly state: State = {};

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    if (!this.state.error) return this.props.children;
    return (
      <ErrorCard text="Something went wrong, we are sorry for the inconvenience." />
    );
  }
}

export default ErrorBoundary;
